import React, { useState, useEffect } from "react";
import { api } from "../api/api";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const UserSidebar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();
  

  // Check if user is logged in on component mount
  useEffect(() => {
    api.get("/users/checklogin", {withCredentials: true}).then((response) => {
      setUser(response.data.user.user);
      setIsLoggedIn(true);
    }).catch(() => setUser(null));
  }, []);

  const handleSignOut = () => {
    api.get("/users/logout", {withCredentials: true});
    setIsLoggedIn(false);
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div>
      {/* Button to toggle sidebar */}
      <button
        onClick={toggleSidebar}
        className=" z-30 p-2 rounded-lg  text-black hover:text-[#6f48e5]  focus:outline-none flex items-center space-x-3 rtl:space-x-reverse transition-transform duration-300 hover:scale-105 "
      >
       <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
      </button>

      {/* Sidebar */}
      <div
        className={`fixed left-0 top-0 h-full w-64 bg-white shadow-lg z-20 transform transition-transform duration-200 ease-in-out ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Sidebar Header */}

        {isLoggedIn ? (
          <div className="bg-gradient-to-r from-[#6f48e5] to-[#8b6bef] px-4 py-6 text-white">
            <div className="font-semibold text-lg">
              {user && `${user.firstName} ${user.lastName}`}
            </div>
            <div className="text-sm text-white/90 truncate">
              {user && user.email}
            </div>
          </div>
        ) : (
          <div className="bg-gradient-to-r from-[#6f48e5] to-[#8b6bef] px-4 py-6 text-white">
            <div className="font-semibold text-lg">Guest User</div>
            <div className="text-sm text-white/90 truncate">Login for view details!</div>
          </div>
        )}


        {/* Sidebar Menu */}
          <ul className="py-4">
            {isLoggedIn ? (
              <li>
                <Link to="/profile">
                <div
           
            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                >
            <svg
              className="w-5 h-5 mr-3 text-[#6f48e5]"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clipRule="evenodd"
              ></path>
            </svg>
            Profile
                </div>
                </Link>
              </li>
            ) : (
              <li>
                <a
            href="#"
            onClick={() => Swal.fire({icon:"warning", title: "Please Sign in", text: "You need to sign in to view profile"})}
            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                >
            <svg
              className="w-5 h-5 mr-3 text-[#6f48e5]"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clipRule="evenodd"
              ></path>
            </svg>
            Profile
                </a>
              </li>
            )}
            <li>
              <Link to="/addVehicle">
              <div
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
              >
                <svg
            className="w-5 h-5 mr-3 text-[#6f48e5]"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
                >
            <path
              fillRule="evenodd"
              d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 3.586L15.414 7A2 2 0 0116 8.586V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
              clipRule="evenodd"
            ></path>
                </svg>
                Add Vehicle
              </div>
              </Link>
            </li>
            <li>
              <Link to="/vehicles">
              <div
               
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
              >
               <svg
  className="w-5 h-5 mr-3 text-[#6f48e5]"
  fill="currentColor"
  viewBox="0 0 20 20"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    d="M6.5 4C5.67 4 4.94 4.56 4.7 5.35L3 10v5c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-5l-1.7-4.65C14.06 4.56 13.33 4 12.5 4h-6zM5.5 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 9l1-3h8l1 3H5z"
    clipRule="evenodd"
  />
</svg>
                Vehicle Page
              </div>
              </Link>
            </li>      
            {/* Conditional Rendering for Sign Up and Sign In */}
          {!isLoggedIn && (
            <>
              <li>
                <Link to="/signUp">
                <div
                 
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                >
                  <svg
                    className="w-5 h-5 mr-3 text-[#6f48e5]"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  Sign Up
                </div>
                </Link>
              </li>
              <li>
                <Link to="/signIn">
                <div
                
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                >
                  <svg
                    className="w-5 h-5 mr-3 text-[#6f48e5]"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  Sign In
                </div>
                </Link>
              </li>
            </>
          )}

          {/* Conditional Rendering for Sign Out */}
          {isLoggedIn && (
            <li>
              <a
                href="#"
                onClick={handleSignOut}
                className="flex items-center px-4 py-2 text-sm text-[#6f48e5] hover:bg-[#6f48e5]/5 font-medium transition-colors duration-150"
              >
                <svg
                  className="w-5 h-5 mr-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Sign Out
              </a>
            </li>
          )}
        </ul>
      </div>

      {/* Overlay to close sidebar when clicking outside */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-10"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
};

export default UserSidebar;